import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faFilePdf, faImage } from '@fortawesome/pro-regular-svg-icons'

import type { FileType } from './types'

export const FILE_TYPE_TO_EXTENSION: Record<FileType, string> = {
  'application/pdf': '.pdf',
  'image/jpeg': '.jpg',
  'image/png': '.png',
  'image/gif': '.gif',
}

export const FILE_TYPE_TO_ICON: Record<FileType, IconDefinition> = {
  'application/pdf': faFilePdf,
  'image/jpeg': faImage,
  'image/png': faImage,
  'image/gif': faImage,
}

export const DEFAULT_ACCEPETED_FILE_TYPES: FileType[] = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'application/pdf',
]
